import React, { memo, forwardRef } from "react";
const SvgCapitalK = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M21.28 20.94c.187.187.32.367.4.54.08.16.12.327.12.5 0 .373-.12.68-.36.92s-.553.36-.94.36c-.16 0-.333-.04-.52-.12a1.937 1.937 0 01-.54-.4l-6.66-6.76h-.06v5.86c0 .307-.046.553-.14.74a1.345 1.345 0 01-.34.42.814.814 0 01-.4.2c-.146.04-.273.06-.38.06-.107 0-.233-.02-.38-.06a.938.938 0 01-.42-.2 1.516 1.516 0 01-.32-.42c-.093-.187-.14-.433-.14-.74V10.16c0-.293.047-.533.14-.72.094-.187.2-.333.32-.44a.938.938 0 01.42-.2c.147-.04.274-.06.38-.06.107 0 .233.02.38.06.147.027.28.093.4.2.133.107.247.253.34.44.094.187.14.427.14.72v4.88h.06l6.32-5.82c.187-.187.367-.313.54-.38.174-.067.334-.1.48-.1.347 0 .627.113.84.34.227.213.34.48.34.8 0 .147-.033.313-.1.5-.053.173-.193.353-.42.54l-5.24 4.54 5.74 5.48z"
      />
    </svg>
  );
});
SvgCapitalK.displayName = "SvgCapitalK";
const MemoForwardRef = memo(SvgCapitalK);
export default MemoForwardRef;
